export default (s) => (s ? s.replace(/_/g, '___')
  .replace(/\$/g, '_D_')
  .replace(/#/g, '_H_')
  .replace(/\[/g, '_O_')
  .replace(/\]/, '_C_')
  .replace(/\//g, '_S_') : '');
// .replace(/nan/g, '_NULL_');
//   .replace(/\./g, '_P_')
//   .replace(/ /g, '_B_')
